import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';

import { RouterStateUrl } from '@sd-portal/shared/util';

import { State } from '..';
import * as tripManagerQuery from './trip-manager.selectors';
import * as actions from './trip-manager.actions';

@Injectable()
export class TripManagerFacade {
  postedAircraftTripSkeletonsLoading$ = this.store.pipe(
    select(tripManagerQuery.getPostedAircraftTripSkeletonsLoading)
  );
  postedAircraftTripSkeletonsLoaded$ = this.store.pipe(
    select(tripManagerQuery.getPostedAircraftTripSkeletonsLoaded)
  );
  postedAircraftTripSkeletons$ = this.store.pipe(
    select(tripManagerQuery.getPostedAircraftTripSkeletons)
  );

  postedAircraftTripAuditLoading$ = this.store.pipe(
    select(tripManagerQuery.getPostedAircraftTripAuditLoading)
  );
  postedAircraftTripAuditLoaded$ = this.store.pipe(
    select(tripManagerQuery.getPostedAircraftTripAuditLoaded)
  );
  postedAircraftTripAudit$ = this.store.pipe(select(tripManagerQuery.getPostedAircraftTripAudit));

  postedAircraftTripLegAuditLoading$ = this.store.pipe(
    select(tripManagerQuery.getPostedAircraftTripLegAuditLoading)
  );
  postedAircraftTripLegAuditLoaded$ = this.store.pipe(
    select(tripManagerQuery.getPostedAircraftTripLegAuditLoaded)
  );
  postedAircraftTripLegAudit$ = this.store.pipe(
    select(tripManagerQuery.getPostedAircraftTripLegAudit)
  );

  constructor(
    private readonly store: Store<{
      router: RouterReducerState<RouterStateUrl>;
      sharedAudit: State;
    }>
  ) {}

  loadPostedAircraftTripSkeletons() {
    this.store.dispatch(actions.ResetTripManager());
    this.store.dispatch(actions.LoadPostedAircraftTripSkeletons());
  }

  loadPostedAircraftTripAudit(postedAircraftTripId: number) {
    this.store.dispatch(actions.LoadPostedAircraftTripAudit({ postedAircraftTripId }));
  }

  nextPostedAircraftTripAuditPage(postedAircraftTripId: number) {
    this.store.dispatch(actions.LoadNextPagePostedAircraftTripAudit({ postedAircraftTripId }));
  }

  loadPostedAircraftTripLegAudit(event: { postedAircraftTripId: number; postedFlightId: number }) {
    this.store.dispatch(
      actions.LoadPostedAircraftTripLegAudit({
        postedAircraftTripId: event.postedAircraftTripId,
        postedFlightId: event.postedFlightId
      })
    );
  }

  nextPostedAircraftTripLegAuditPage(event: {
    postedAircraftTripId: number;
    postedFlightId: number;
  }) {
    this.store.dispatch(
      actions.LoadNextPagePostedAircraftTripLegAudit({
        postedAircraftTripId: event.postedAircraftTripId,
        postedFlightId: event.postedFlightId
      })
    );
  }
}
